import { render, staticRenderFns } from "./OutingList.vue?vue&type=template&id=2487b5d8&scoped=true&lang=pug"
import script from "./OutingList.vue?vue&type=script&lang=ts"
export * from "./OutingList.vue?vue&type=script&lang=ts"
import style0 from "./OutingList.vue?vue&type=style&index=0&id=2487b5d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2487b5d8",
  null
  
)

export default component.exports